var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"timeline_register",attrs:{"id":"timeline_register","hide-footer":"","centered":"","no-close-on-backdrop":"","title":_vm.title}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }